import { urlSafeDecode } from "@aws-amplify/core";
import React from "react";
import { Link } from "react-router-dom";
// import Div1 from "../../images/div1goldWin.jpg";
// import OrvarOpen from "../../documents/Orvar_Open.pdf";
// import HostLov from "../../documents/Höstlovsläger.pdf";
// import Distriksdomare from "../../images/domarutbildning_500.png";
import NextGen from "../../images/nextgen.jpeg";
import SportLov from "../../images/SLT_500.png";
import AJ_U8 from "../../images/aggjakten2026_u8.jpg";
import AJ_U12 from "../../images/aggjakten2026_u12.jpg";
import AJ_HCP from "../../images/aggjakten2026_hcp.jpg";
import Markescermoni from "../../images/markescermoni_juni_2026.jpg";
import Div1Guld from "../../images/markescermoni_div1_guld.jpg";
import Pensionarer from "../../images/markescermoni_pensionarer.jpg";
import Final from "../../images/final_sommartavling.jpg";
import Sommartavling from "../../images/djurgarden_pingis_collage_500px.jpg";
// import Diffestival from "../../images/djurgardsfestivalen_2026.jpg";
import Boo from "../../images/boo.jpg";
import MalarnOpen from "../../images/malarn_open.jpg";
import OrvarOpen2026 from "../../images/OrvarOpen2026.jpg";
import OrvarOpenFinal2026 from "../../images/OrvarOpenFinal2026.jpg";

const HomePageText = () => {
  return (
    <div>
      <h1>Välkommen till Djurgården Bordtennis</h1>
      <div>
        <p>
          Välkommen att spela pingis med Djurgården i någon av våra
          träningsgrupper - seniorer, ungdomsgruppen samt de olika
          pingisskolorna. Från motionspingis till tävlings- och seriespel för
          damer och herrar i alla åldrar.
        </p>
      </div>
      <div class="flex-container">
        <div class="flex-item">
          <h2>AKTUELLT</h2>
          <p>
            Djurgården tar ställning mot återkomst av ryskt idrottande.{" "}
            <Link to="/vardegrund">Läs mer här</Link>.
          </p>

          <h3>Kommande viktiga datum</h3>

          <p>
            <ul className="custom-list">
              {/* <li>Augusti-September Silly Season</li> */}
              {/* <li>5/9 Djurgårdsfestivalen på Stadion</li> */}
              <li>19/9 Seriestart nationella serierna</li>
              <li>6/10 Seriestart distriktsserierna</li>
              <li>1/11 Orvar Open & Märkescermoni</li>
              <li>4/11 Ny omgång av Pingiskola 1 </li>
              <li>20/12 Julavslutning</li>
            </ul>
          </p>
          <h3>Orvar Open & Märkescermoni</h3>
            <p>Orvar Open fick avsluta höstlovet och vilken pingisfest det blev!</p>
            <img
               class="main-flex-item-image"
              src={OrvarOpen2026}
              alt="Flickor och pojkar som tävlar i pingis, Orvar Open 2026, Djurgårdens pingisklubb Stockholm."
            />
          <p> Paradgrenen mixed-dubbel hade i år hela 14 deltagare, Orvar är lite girig och hoppas på ännu fler nästa år!</p>
            <ul className="custom-list">
              <li>Mixed-dubbel: 1. Sofie & Nicolas, 2. Jessie & Knut, 3. Amanda & Albin, Emelie & Nils </li>
              <li>Öppen: 1. Tommi R, 2. Jessie C, 3. Albin J, 4. Jonatan B, 5. Patrik O, 6. Patrik B</li>
              <li>U15: 1. August L, 2. Albert N, 3. Nils A, 4. Emelie N F, 5. Oiver G, 6. Elsa Å</li>
              <li>Ungdom Röd: 1. Aston S, 2. Charlie S, 3. Leo W, 4. Alex L, 5. Leia N, 6. Miles L</li>
            </ul>
            <img
               class="main-flex-item-image"
              src={OrvarOpenFinal2026}
              alt="Final i mixed-dubbel, Orvar Open 2026, Djurgårdens pingisklubb Stockholm."
            />
            <p>Finalen i öppna klassen blev även denna gång en uppgörelse mellan damerna och herrarnas representationlag. Tzu Jessie Chen tog revansch från Sommartävlingen när hon lyckades besegra herrarnas Albin Johansson i semifinalen. I finalen fick hon dock se sig besegrad av herrarnas Tommi Riihonen.</p>
          <h3>Tävlingssäsongen igång</h3>
          <div className="image-text-row">
            <img
              className="image-text-row-image"
              src={MalarnOpen}
              alt="Pelle efter vinst i P10."
            />
            <div>
              <p>
                Utöver seriespelet har årets tävlingssäsong kommit igång
                ordentligt. Under oktobers andra helg var det Djurgårdare ute i
                tävlingar från Skellefteå i norr till Linköping i söder.
              </p>
              <p>
                Det har varit lärorika matcher som vi tar med in resten av
                säsongen. Alltid kul att möta nya spelare.
              </p>
              <p>På bild: Pelle efter vinst i P10.</p>
            </div>
          </div>

          <p>
            <img
              class="main-flex-item-image"
              src={Boo}
              alt="Flickor och pojkar som tävlar i pingis."
            />
          </p>
          <p>
            Under oktobers första helg kunde man hitta Djurgårdens spelare ute
            på flera olika tävlingar.
          </p>
          <p>
            På bild: Emelie med sin pokal från Pojkar 12, Boo Cup, Nikan i full
            action under sin semifinal i samma tävling.
          </p>
          {/* <h3>Djurgårdsfestivalen</h3>
          <p>
            Djurgårdsfestivalen äger rum på Stadion den 5 september, kl. 9-18. Kom och spela pingis med oss, testa andra sporter och heja fram Djurgården i lördagens fotbollsmatch mot Rosengård klockan 14:00.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Diffestival}
              alt="Djurgårdsfestivalen 2026, Djurgårdens pingisklubb Stockholm."
            />
          </p> */}
          <h3>Pingisskolan</h3>
          <p>
            En ny omgång av pingisskolan för nya intresserade startar i början
            av november.
          </p>
          <p>
            Pingisskolan vänder sig till flickor och pojkar från ca 6-7 år och
            äldre. För att få plats i Pingisskolan kontaktar du kansliet via{" "}
            <a href="mailto: difbtx@gmail.com">difbtx@gmail.com </a>
            för anmälan och aktuell information om lediga platser.
          </p>
          <h3>Sommartävling</h3>
          <p>
            Sommartävlingen är vår klassiska avslutning på både sommarlägret och
            säsongen.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Final}
              alt="Finalen i sommartävlingen 2026, Djurgårdens pingisklubb Stockholm."
            />
          </p>
          <p>
            Årets final i Öppna klassen blev en uppgörelse mellan våra
            representationslag. Herrarnas Albin Johansson ställdes mot damernas
            Tzu "Jessie" Chen. Publiken hölls på spänning i 5 jämna set innan
            Albin till slut kunde räkna hem segern. I bakgrunden ser vi finalen
            i U12 där Winston Derninger efter en hård kamp kunde bärga guldet
            efter vinst mot August Lund.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Sommartavling}
              alt="Sommartävlingen 2026, tjejer och killar gör upp i en bordtennistävling."
            />
          </p>
          <p>
            Denna gång ställde över 30 djurgårdare upp i årets Sommartävling. Vi
            passade även på att dela ut säsongens sista pingismärken.
            <ul className="custom-list">
              <li>U8: 1 Nicolas B, 2 Tom V, 3 Amanda S, 4 Stellan W </li>
              <li>U12: 1 Winston D, 2 August L, 3 Ludvig P L, 4 Nils A</li>
              <li>Öppen: 1 Albin J, 2 Jessie C, 3 Ludvig P L, 4 Jonatan B</li>
            </ul>
          </p>
          <h3>Märkesregn över Pingisskolan</h3>
          <p>
            Det var ett härligt gäng som under vårens sista veckor betat av
            olika moment på sina pingismärken. Längst denna gång hade Ludvig
            kommit som tog silver och guld av bara farten på 12 dagar. Måste
            vara klubbrekord av något slag. Grattis till hela gänget.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Markescermoni}
              alt="Flickor och pojkar tar pingismärken i bordtennis, Djurgårdens pingisskola Stockholm."
            />
          </p>
          <h3>Guldgubbar</h3>
          <p>
            Onekligen en lyckad debut för det nyskapade laget i
            pensionärsserien. Guld på första försöket för laget.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Pensionarer}
              alt="Djurgårdens pensionärslag firar guld i pensionärsserien."
            />
          </p>
          <p>På bild: Karl-Åke, Joakim, Paul och Tommi. Saknas gör Anders.</p>
          <h3>Guld-damerna värmdes upp</h3>
          <p>
            Under terminsavslutningen uppmärksammades damernas A-lag för sin
            seger i div 1 tidigare i vår. Ryktet sa att de frös mellan matcherna
            under de långa sammandragen. Så klubben gav de varsin varm
            collegetröja inför nästa säsong. Lagets maskot fick ta emot tröjan
            åt lagets ankare Zheting som var bortrest.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Div1Guld}
              alt="Tjejer och damer i Djurgårdens bordtennisklubb firar guld i division 1, Stockholm."
            />
          </p>
          <p>På bild: Jessie, klubbens maskot Orvar och Sofie.</p>

          {/* <h3>Distriktsdomarutbildning</h3>
          <p>
            I samband med det nationella sammandraget som hölls i november på
            GIH examinerades ett antal distriksdomare från klubben. Bra jobbat
            alla kursdeltagare!
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Distriksdomare}
              alt="Djurgårdens damer i bordtennis i serieledning."
            />
          </p> */}
          {/* <h3>26 oktober - 2 november - Höstlovsläger</h3>
          <p>
            Vad kan vara bättre än att fira höstlovet med en vecka fylld av
            pingis? Se affisch för mer info och inspiration. Extra märkestagning
            kommer anordnas för deltagare under lägret. Anmälan senast 24/10
            till <a href="mailto: difbtx@gmail.com">difbtx@gmail.com</a>
          </p>
          <p>
            <a href={HostLov}>Inbjudan till Höstlovsläger</a>
          </p> */}

          {/* <p>
            <img
              class="main-flex-item-image"
              src={Div1}
              alt="Djurgårdens damer i bordtennis i serieledning."
            />
          </p> */}

          {/* <p>Seriespelet är nu igång för alla våra tio lag. De består av ett flicklag, tre damlag, två ungdomslag, två herrlag samt två lag i veteranserierna.</p> */}
        </div>
        <div class="flex-item">
          <h3>Resultat Äggjakten</h3>
          <p>
            9 april gick årets äggjakt av stapeln, det bjöds på hårda matcher
            och riktigt fint spel. Extra kul att vi denna gång hade flera
            deltagare som gjorde sin första tävling nånsin!
            <ul className="custom-list">
              <li>U8: 1 Nicolas B, 2 Ludwig K A, 3 Sixten T, 4 Jonathan F</li>
              <li>U12: 1 Theo Ö, 2 Ludvig P L, 3 Sebastian A, 4 Albert N</li>
              <li>HCP: 1 Ludvig P L, 2 Oscar M F, 3 Theo Ö & Nicolas B</li>
            </ul>
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={AJ_U8}
              alt="Flickor och pojkar spelar bordtennis och pingis i Äggjakten 2026, Djurgården Stockholm."
            />
          </p>
          <p>På bild: Deltagare i U8, Äggjakten 2026</p>
          <p>
            <img
              class="main-flex-item-image"
              src={AJ_U12}
              alt="Tjejer och killar tävlar i bordtennis, Äggjakten U12 2026, Djurgårdens pingisklubb Stockholm."
            />
          </p>
          <p>På bild: Deltagare i U12, Äggjakten 2026</p>
          <p>
            <img
              class="main-flex-item-image"
              src={AJ_HCP}
              alt="Tjejer och killar i HCP-cupen, bordtennistävling Äggjakten 2026, Djurgården Stockholm."
            />
          </p>
          <p>
            På bild: Topp 4 i HCP-cupen, Äggjakten 2026. Saknas på bild: Nicolas
            B
          </p>
          {/* <h3>Guld i division 1</h3>
          <p>
            Guldet bärgades i Vällingby och nu väntar Superettankval 11-12/4.
            Det är en fantastisk prestation av våra damer att vinna division 1
            och vi önskar dem lycka till i kvalet!
          </p>
          <p>
            Extra kul att vi hade publik på plats under bägge de två sista
            matcherna.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={Div1}
              alt="Damer från djurgården jagar guld."
            />
          </p> */}

          <h3>Resultat sportlovstävling</h3>
          <p>
            1 mars gick årets sportlovstävling av stapeln, ett 20-tal
            ungdomsspelare hade tagit sig tillbaka till stan för att göra upp i
            3 klasser. Det bjöds på hårda matcher och riktigt fint spel - bådar
            gott inför en spännande vårsäsong. Stort grattis till alla vinnare
            och deltagare!
            <ul className="custom-list">
              <li>U8: 1 Ebbot N, 2 Nicolas B, 3 Oscar M F, 4 Elton S</li>
              <li>
                U11, A-slutspel: 1 Theo Ö, 2 Winston D, 3 Nikola M, 4 Jacob C
              </li>
              <li>
                U11, B-slutspel: 1 Nicolas B, 2 Emelie N F, 3 Alexander L, 4
                Felix F
              </li>
              <li> Öppen: 1 Albin J, 2 Jacob L, 3 Theo Ö, 4 Oliver G</li>
            </ul>
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={SportLov}
              alt="Tjejer och killar tävlar i bordtennis, Djurgårdens sportlovstävling 2026 Stockholm."
            />
          </p>
          <h3>Epoker kommer och går</h3>
          <p>
            Idrottande skapar ständigt nya minnen. Händelser blir historiska när
            man minst anar det. För kalenderbitare tycks inga stunder - stora
            som små - vara för obetydliga för att beskrivas som unika. Allt
            beror på sammanhanget. Att det ibland infinner sig samma känsla även
            hos andra är knappast heller helt ovanligt. Man undrar: Har det här
            ens hänt förut.
          </p>
          <p>
            Så till saken. Det är nu den 9 mars 2026 och fullt med pingisspelare
            i rackethallen i Nacka, hemmaplan för Boo RK som bara veckan
            tidigare hade självaste J-O Waldner och broder Kjell-Åke som
            motståndare i div 4. Fast i en annan och större hall och mer publik.
            Historiskt? Absolut, men också nostalgi.
          </p>
          <p>
            Serielunken rullar alltså på i samma division och Djurgården är nu
            gästande lag som så många gånger förut. Tre djurgårdare och
            lagledare har just klivit in och är på plats. En snabb koll på
            mobilen för att se att fjärdemannen är på ingång. Jodå. Allt är i
            sin ordning. Men det är inte riktigt som vanligt. Ett 15-tal
            entusiaster i publiken fick, tämligen ovetandes, bevittna något
            sällsynt. Inte inköpta spektakulära spelare, inte inlånade spelare
            eller inringda gamla trotjänare. Men denna gång är det ett ungt och
            piggt gäng som är helt och fullt fostrade i klubben sedan barnsben.
            Inga andra klubbar inblandade, inga värvningar. Ren och skär
            generationsväxling - rakt över hela linjen! Epoker klingar av och
            andra kanske inleds.
          </p>
          <p>
            För hur vanligt är det egentligen att samtliga spelare i en klubbs
            representationslag är sprungna ur en och samma pingisskola? Ingen
            tycks påminna sig att något liknande ägt rum i Djurgården under i
            vart fall det senaste halvseklet. Spelande lagledare Tommi Riihonen
            har varit med i klubben sedan 1980-talet och anar att söndagens
            A-lagsmatch på sitt sätt därför är unik.
          </p>
          <p>
            <cite>
              Att det blev ett renodlat djurgårdsgäng just i denna match var
              inte givet på förhand. Men planen att föryngra A-laget med spelare
              enbart från de egna leden har funnits rätt länge
            </cite>
            , säger Tommi. Och bakom det här gänget står ett helt koppel yngre
            spelare som gärna vill in i A-laget.
          </p>
          <p>
            Efter att ha fokuserat de senast åren på dam- och flicklagen ser det
            ut att bli herrarnas tur ett tag framöver. De som i först hand tar
            täten är Albin Johansson, Jacob Lewinschal, Amadeus Petri, Hugo
            Tammerlöv och Abbe Evers. Inte otroligt att de kan tänkas ha många
            år framför sig. Genomsnittsåldern är nämligen endast 16 år.
          </p>
          <p>
            <img
              class="main-flex-item-image"
              src={NextGen}
              alt="Unga bordtennisspelare i Djurgårdens pingisklubb Stockholm, herrlagets nästa generation."
            />
            Next generation - Hugo Tammerlöv, Abbe Evers, Tommi Riihonen
            (lagledare), Jacob Lewinschal och Albin Johansson. Saknas på bild:
            Amadeus Petri.
          </p>

          <h3>Nya seniorer</h3>
          <p>
            För dig som inte har spelat organiserat tidigare, eller som vill
            återuppta pingisen, går det bra att anmäla sig till någon av
            vuxengrupperna för motionärer eller tävlingsspelare. Kontakta
            kansliet på <a href="mailto: difbtx@gmail.com">difbtx@gmail.com</a>{" "}
            för att få aktuell information om lämplig grupp för din nivå.
          </p>
          <h3>Welcome to Djurgården Bordtennis!</h3>
          <p>
            Table-tennis for everyone, regardless of age and skills. For more
            information please send an e-mail to{" "}
            <a href="mailto: difbtx@gmail.com">difbtx@gmail.com</a>. You will be
            contacted as soon as possible.
          </p>
        </div>
      </div>
      <div>
        <p>Vi ses i pingishagen!</p>
        <p>Djurgården Bordtennis</p>
        <p>
          Kansliet e-post:{" "}
          <a href="mailto: difbtx@gmail.com">difbtx@gmail.com</a>
        </p>
      </div>
    </div>
  );
};

export default HomePageText;
